"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeCategory = exports.deleteCategory = exports.updateCategoryOrder = exports.updateCategories = exports.updateCategory = exports.addCategory = exports.getComplianceCategories = exports.getCategories = void 0;
const shared_1 = require("@getgreenline/shared");
const getCategories = (companyId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.get(`/api/v1/company/${companyId}/categories`);
    return response.data.categories;
});
exports.getCategories = getCategories;
const getComplianceCategories = (companyId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.get(`/api/v1/company/${companyId}/categories/complianceCategories`);
    return response.data.data;
});
exports.getComplianceCategories = getComplianceCategories;
const addCategory = (companyId, createObject) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.post(`/api/v1/company/${companyId}/categories`, createObject);
    return response.data;
});
exports.addCategory = addCategory;
const updateCategory = (companyId, categoryId, createObject) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.put(`/api/v1/company/${companyId}/category/${categoryId}`, createObject);
    return response.data;
});
exports.updateCategory = updateCategory;
const updateCategories = (companyId, updateObject) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.put(`/api/v1/company/${companyId}/categories`, updateObject);
    return response.data;
});
exports.updateCategories = updateCategories;
const updateCategoryOrder = (companyId, ordering) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.put(`/api/v1/company/${companyId}/categories/order`, {
        order: ordering,
    });
    return response.data;
});
exports.updateCategoryOrder = updateCategoryOrder;
const deleteCategory = (companyId, categoryId, newCategoryId) => __awaiter(void 0, void 0, void 0, function* () {
    return yield shared_1.axios.delete(`/api/v1/company/${companyId}/category/${categoryId}`, {
        params: {
            newCategoryId: newCategoryId,
        },
    });
});
exports.deleteCategory = deleteCategory;
const mergeCategory = (companyId, categoryId, newParentCategoryId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.post(`/api/v1/company/${companyId}/category/${categoryId}/merge`, {
        newParentCategoryId: newParentCategoryId,
    });
    return response.data;
});
exports.mergeCategory = mergeCategory;
//# sourceMappingURL=api.js.map